import "./ARButton.css"
import { isMobile } from 'react-device-detect';
import { ReactComponent as ArIcon } from "../../media/ar.svg";

const ARButton = (props) => {

    function iOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      }


    let modelUrl = null;

    if(isMobile) {
        if(iOS()) {
            modelUrl = props.usdzFileUrl;
        } else {
            modelUrl = `intent://arvr.google.com/scene-viewer/1.0?file=${props.glbFileUrl}&mode=ar_only#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${props.fallbackUrl};end;`
        }
    }

    const openModelUrl = () => window.location.href = modelUrl;

    const onButtonClicked = () => {
        if(isMobile) {
            props.logArButtonClickedMobile();
        } else {
            props.logArButtonClickedDesktop();
            props.setQRCodeModalVisible(true);
        }
    }
    return isMobile ? (
      <a rel="ar" onClick={onButtonClicked} className="btn-ar" href={modelUrl}>
        <img src="" style={{ display: "none" }} alt="" />
        <div className="btn-ar-content">
        <p className="view-text">View in your space</p>
        <ArIcon className="btn-ar-icon"/>
        </div>
      </a>
    ) : (
      <button className="btn-ar" onClick={onButtonClicked}>
        <p className="view-text">View in your space</p>
        <ArIcon className="btn-ar-icon"/>
      </button>
    );

}
 
export default ARButton;